<template>
    <div v-if="checkAuthorization.allow">
        <v-card-title class="portletTitle">{{ $t(getTranslation) }}</v-card-title>
        <br />
        <SearchBarGS :clientId="getCurrentClientId" :portletId="getPortletId" />

        <v-skeleton-loader v-if="loading" :loading="loading" type="table"></v-skeleton-loader>
        <v-card class="results" v-if="getListResult">
            <v-toolbar class="elevation-0">
                <v-toolbar-title> {{ getListResult.length }} {{ $t('forms.results') }} </v-toolbar-title>

                <v-text-field
                    v-model="search"
                    :label="$t('forms.search')"
                    single-line
                    hide-details
                    color="#3200E6"
                    class="search"
                    append-icon="mdi-magnify"
                />
            </v-toolbar>

            <div class="content">
                <ResultTable
                    :configHeadersId="getHeaderConfigId()"
                    :items="getListResult"
                    :search="search"
                    :saveChanges="true"
                    skin="elevation-0"
                />
            </div>
        </v-card>
    </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex';
import ResultTable from '@/components/ResultTable';
import SearchBarGS from '@/components/SearchBarGS';

export default {
    components: {
        SearchBarGS,
        ResultTable
    },
    data: () => ({
        search: '',
        headersFromConfig: null
    }),
    methods: {
        ...mapGetters(['getPortletsList', 'getCurrentPortlet']),
        ...mapMutations(['resetListResult']),
        getHeaderConfigId() {
            return this._getClient && this.getPortletId ? `GS_${this.getCurrentClientId}_${this.getPortletId}` : 'GS_DEFAULT';
        }
    },
    computed: {
        ...mapGetters(['getPortletId', '_getClient', 'getCurrentClientId', 'getListResult']),
        ...mapState({ loading: state => state.loader.loading }),
        checkAuthorization() {
            return {
                allow: this.$store.state.groups.userRoles?.genericsearch?.user || this.$store.state.groups.authorization?.admin
            };
        },
        getTranslation() {
            const key = `genericSearch.${this.getCurrentClientId}.${this.getPortletId}.name`;
            return this.$te(key) ? this.$t(key) : this.$t('genericSearch.default.name');
        }
    },
    mounted() {
        this.resetListResult();
    }
};
</script>
<style lang="scss" scoped>
.portletTitle {
    font-size: 1.8rem;
}

form {
    overflow: hidden;
    &._hidden {
        height: 0px;
    }
}

.search-form {
    margin-bottom: 20px;
    .v-card__actions {
        position: absolute;
        top: 5px;
        right: 20px;
    }
}

.search {
    margin-left: 32px;
    max-width: 316px;
}

.content {
    margin: 0 16px;
}

.results {
    margin: 16px 0;
}
</style>
